// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseQuestionRejectedCheckbox_root__1XmEl","icon":"CloseQuestionRejectedCheckbox_icon__1_XJz","active":"CloseQuestionRejectedCheckbox_active__3jeYS"};